import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'الصفحة الرئيسية',
    icon: 'home-outline',
    link: '/admin',
  },
  {
    title: 'الخدمات',
    link: '/admin/services',
    // icon: 'briefcase-outline',
    icon: 'grid-outline',
  },
  // {
  //   title: 'دليل السياسات',
  //   link: '/admin/policies',
  //   icon: 'alert-triangle-outline',
  // },
  {
    title: 'إدارة سير العمل',
    link: '/admin/workflow',
    // icon: 'star',
    icon: 'briefcase-outline',
  },
  {
    title: 'عن المجمع',
    link: '/admin/about',
    // icon: 'list',
    icon: 'info-outline',
  },
  // {
  //   title: 'الإدارات',
  //   link: '/admin/managements',
  //   icon: 'layers-outline',
  //   // icon: 'person',
  // },
  {
    title: 'الأخبار',
    link: '/admin/news',
    // icon: 'grid-outline',
    icon: 'book-open-outline',
  },
  {
    title: 'الفعاليات',
    link: '/admin/events',
    // icon: 'grid-outline',
    icon: 'star-outline',
  },
  {
    title: 'الوسائط',
    link: '/admin/blogs',
    // icon: 'grid-outline',
    icon: 'image-outline',
  },{
  title: 'المشاركة الإلكترونية',
  link: '/admin/electronicsharing',
  icon: 'edit-outline',
  },
  {
    title: 'مرافق المجمع',
    link: '/admin/complex-attachements',
    // icon: 'grid-outline',
    icon: 'archive-outline',
  },
  {
    title: ' إضافات المستودع',
    link: '/admin/dspace',
    // icon: 'grid-outline',
    icon: 'gift-outline',
  },
  {
    title: 'الشركاء',
    link: '/admin/partners',
    // icon: 'grid-outline',
    icon: 'gift-outline',
  },
  {
    title: ' إحصائيات المستودع',
    link: '/admin/dspace-statistics',
    icon: 'pie-chart-outline',
  },

  // {
  //   title: 'مجلس الأمناء',
  //   link: '/admin/board-of-trustees',
  //   icon: 'people-outline',
  // },
  {
    title: 'اللجان',
    link: '/admin/committees',
    icon: 'person-outline',
  },
  // {
  //   title: 'المكتبات',
  //   link: '/admin/libraries',
  //   icon: 'book-outline',
  // },
  // {
  //   title: 'الأنظمة واللوائح',
  //   link: '/admin/regulations',
  //   icon: 'file-text-outline',
  // },
  // {
  //   title: ' التقارير',
  //   link: '/admin/reports',
  //   icon: 'file-outline',
  // },
  // {
  //   title: ' الإنجازات',
  //   link: '/admin/achievements',
  //   icon: 'flag-outline',
  // },
  // {
  //   title: ' التعاون المحلي والدولي',
  //   link: '/admin/cooperations',
  //   icon: 'globe-outline',
  // },
  // {
  //   title: 'إدارة الموافقات',
  //   link: '/admin/workflow/requests',
  //   icon: 'file-add-outline',
  // },

  {
    title: 'إدارة المستخدمين',
    link: '/admin/users',

    icon: 'person-add-outline',
  },
  {
    title: 'إدارة الصلاحيات',
    link: '/admin/roles',
    icon: 'person-done-outline',
  },
  // {
  //   title: ' إدارة النماذج ',
  //   expanded: true,
  //   icon: 'message-square-outline',
  //   children: [
  //     { title: 'النماذج', link: '/admin/dynamicForms', icon: 'list-outline' },
  //     { title: 'المصادر', link: '/admin/dynamicForms/sources', icon: 'star-outline' },
  //   ],
  // },
  {
    title: 'الاسئلة المتكررة',
    link: '/admin/questions',
    icon: 'question-mark-circle-outline',
  },
      {
    title: ' المراكز',
    icon: 'home-outline',
    link: '/admin/centers',
  },
   {
    title: 'البوابات',
    icon: 'home-outline',
    link: '/admin/portals',
  },
  {
    title: 'الجهات البحثية',
    icon: 'home-outline',
    link: '/admin/institutions',
  },
  {
    title: 'إعداد النظام',
    expanded: true,
    icon: 'settings-2-outline',
    children: [
      { title: 'أنواع الخدمات', link: '/admin/services-types', icon: 'grid-outline' },
      { title: 'أنواع زيارات المجمع', link: '/admin/visit-types', icon: 'compass-outline' },

      { title: 'المستفيدين', link: '/admin/benefeciaries', icon: 'credit-card-outline' },

      // { title: 'بيانات البريد', link: '/admin/email-contact', icon: 'email-outline' },
      { title: 'بيانات الاتصال', link: '/admin/contact', icon: 'phone-call-outline' },
      { title: 'معلومات المجمع', link: '/admin/complex-info', icon: 'phone-call-outline' },
      { title: ' اتصالات الطوارئ', link: '/admin/emergency-calls', icon: 'phone-call-outline' },
      { title: '  معلومات التطبيق', link: '/admin/app-info', icon: 'phone-call-outline' }
    ],
  }
];
